// frontend/src/components/production-sequence/SequenceModeTabs.tsx
import { useTranslation } from 'react-i18next';
import type { SequenceMode } from '@/hooks/useProductionSequence';

interface Props {
  mode: SequenceMode;
  dark: boolean;
  onChange: (mode: SequenceMode) => void;
}

const MODES: SequenceMode[] = ['produccion', 'fabricacion'];

/** Selector superior de ámbito de la secuencia: Producción (todo menos FABRICACION)
 *  vs Fabricación (solo la línea FABRICACION). */
export function SequenceModeTabs({ mode, dark, onChange }: Props) {
  const { t } = useTranslation();
  const wrap = dark ? 'bg-white/5 border-white/10' : 'bg-slate-100 border-slate-200';
  const active = 'bg-sky-500 text-white shadow-sm';
  const idle = dark ? 'text-slate-300 hover:text-slate-100' : 'text-slate-600 hover:text-slate-900';
  return (
    <div className={`inline-flex items-center gap-1 rounded-xl border p-1 ${wrap}`} role="tablist">
      {MODES.map(m => (
        <button
          key={m}
          role="tab"
          aria-selected={mode === m}
          onClick={() => onChange(m)}
          className={`text-[12px] font-semibold px-3.5 py-1.5 rounded-lg transition-colors cursor-pointer ${mode === m ? active : idle}`}
        >
          {t(`sequence.mode.${m}`)}
        </button>
      ))}
    </div>
  );
}
